import { Grid, IconButton, Stack } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import IGridComponent from '../../../components/grid/i-grid.component';
import { generateId, isEmpty, isNotEmptyArray } from '../../common/util.services';
import './product.component.scss';
import SelectProductComponent from './select-product.component';
import dayjs from 'dayjs';
import { getOwnershipBasedUsers } from '../../user/user.services';
import TextComponent from './edit-text.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import ProductDetailComponent from './product-detail.component';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';
import EditNoteIcon from '@mui/icons-material/EditNote';

const EnquiryProduct = (props: any) => {
  const [open, setOpen] = useState(false);
  const rows: GridRowsProp = [];
  const [enqProduct, setEnqProduct] = useState(rows);
  const appContext = useContext(AppContext);
  const [users, setUsers] = useState<any>();
  const [openCellValue, setOpenCellValue] = useState(false);
  const [openValue, setOpenValue] = useState(false);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [cellTitle, setCellTitle] = useState('');
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState(null);
  const [showMsgDialog, setShowMsgDialog] = useState(false);
  const [message, setMessage] = useState('');

  const columns: GridColDef[] = [
    { field: 'serial', headerName: '#', filterable: false, editable: false, sortable: false, width: 5 },
    { field: 'product', headerName: 'Product', filterable: false, editable: false, sortable: false, width: 100 },
    { field: 'pack', headerName: 'Pc/Pack', filterable: false, editable: false, sortable: false, width: 90 ,
      renderCell: (params: any) => params.row.product.includes('Fabric') ? 'NA' : 0 === params.row.pack ? '' : params.row.pack
    },
    { field: 'quantity', headerName: 'Quantity', filterable: false, editable: true, sortable: false, width: 80 , type: 'number',
      valueSetter: (value, row) => { row.quantity = value; return value; }
    },
    { field: 'uom', headerName: 'UOM', filterable: false, editable: false, sortable: false, width: 75},
    { field: 'description', headerName: 'Description', filterable: false, editable: false, sortable: false, width: 150,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0.5} 
                                sx={{ height: '100%', width: '100%', ml: -0.75 }}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params)}
                                  sx={{p: 0 }}> <EditNoteIcon fontSize="medium" color='secondary'/>
                                </IconButton>{params.row.description}</Stack>)
    },
    {
      field: 'costingTarget', headerName: 'Costing Target', filterable: false, editable: true, sortable: false, width: 120, type: 'date',
      valueFormatter: (costingTarget: any) => dayjs(costingTarget).format('DD-MMM-YYYY'),
      valueSetter: (value, row) => { row.costingTarget = value; return value; }
    },
    { field: 'costingOwner', headerName: 'Costing Owner', filterable: false, editable: true, sortable: false, width: 120, type: 'singleSelect',
      valueOptions: users, 
      valueFormatter: (costingOwner: any) => costingOwner, 
      valueSetter: (value, row) => { row.costingOwner = value; return value; }
    },
    { field: 'costingStatus', headerName: 'Costing Status', filterable: false, editable: false, sortable: false, width: 120 },
    { field: 'conversionStatus', headerName: 'Conv Status', filterable: false, editable: false, sortable: false, width: 120 },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, editable: false, sortable: false, width: 80 },
    { field: 'ageing', headerName: 'Ageing', filterable: false, editable: false, sortable: false, width: 65 },
    { field: 'productRemarks', headerName: 'Remarks', filterable: false, editable: false, sortable: false, width: 120, type: 'string'},
  ];

  useEffect(() => {
    if (isNotEmptyArray(props.enqProduct)) {
      setEnqProduct(updateSerialNumber([...props.enqProduct]));
    }

    getOwnershipBasedUsers('Costing', appContext,
      (response: any) => {
        setUsers(response.data);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
      });
  }, [props.enqProduct]);

  const openProductPopup = (params: any) => {
    setOpen(true);
  }

  const openPrdDetailPage = (value: any) => {
    value.row.isEditable = true;
    if(!value.row.product.includes('Fabric')) {
      value.row.spec1 = value.row.product;
    }
    if(1 === value.row.isAmazon) {
      if(isEmpty(value.row.spec2)) {
        value.row.spec2 = value.row.color;
      }
      if(isEmpty(value.row.spec3)) {
        value.row.spec3 = value.row.size;
      }
      if(isEmpty(value.row.spec4)) {
        value.row.spec4 = value.row.pack;
      }
    }
    if(!value.row.product.includes('Fabric')) {
      value.row.spec4 = value.row.pack;
    }
    setCellValueRow(value.row);
    setCellLabel('Product Specs');
    if(value.row.pojo > 0) {
      value.row.isEditable = false;
      setMessage('The product has a PO/JS. Some specs are not editable.');
      setShowMsgDialog(true);
    } else if(value.row.costing > 0) {
      setMessage('If specs are changed, product costings need to be updated from costing screen.');
      setShowMsgDialog(true);
    } else {
      setOpenPrdDetail(true);
    }
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleCellDoubleClick = (value: any) => {
    const field = value.field;
    value.row.isEditable = true;
    if('description' === field) {
      //moved to edit action
    } else if('productRemarks' === field) {
      setCellValueRow(value.row);
      setCellTitle('Product Remarks');
      setCellLabel('Product Remarks');
      openCellValuePopup();
    } else if('pack' === field && !value.row.product.includes('Fabric')) {
      setCellValueRow(value.row);
      setCellTitle('Specify Pc/Pack');
      setCellLabel('Pc/Pack');

      if(value.row.pojo > 0) {
        appContext.setDialogMessage('The product has a PO/JS. Delete the PO/JS first to edit pack.');
      } else if(value.row.costing > 0) {
        setMessage('If pack is changed, product costings need to be updated from costing screen.');
        setShowMsgDialog(true);
      } else if(1 === value.row.isAmazon) {
        appContext.setDialogMessage('Pack is not editable for Amazon products.');
      } else {
        setOpenValue(true);
      }
    }
  }

  const onOkClick = () => {
    if('Pc/Pack' === cellLabel) {
      setOpenValue(true);
    } else {
      setOpenPrdDetail(true);
    }
  }

  const closeCellValuePopup = () => {
    setOpenCellValue(false);
  }

  const openCellValuePopup = () => {
    setOpenCellValue(true);
  }

  const closeValuePopup = () => {
    setOpenValue(false);
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const updateSerialNumber = (updatedRow: any) => {
    if (isNotEmptyArray(updatedRow)) {
      updatedRow.forEach((element: any, index: number) => {
        element.serial = index + 1;
      });
    }
    return updatedRow;
  }

  const onRowSelection = (selectedRows: any) => {
    setOpen(false);
    let updatedRow = [...enqProduct];
    for(let i = 0; i < selectedRows.length; ++i) {
      updatedRow.push(selectedRows[i]);
    }
    updatedRow = updateSerialNumber(updatedRow);
    setEnqProduct(updatedRow);
    if (props.onRowSelection) {
      props.onRowSelection(updatedRow);
    }
  }

  const copyRow = (row: any) => {
    let newRow = {id: generateId(), serial: row.serial + 1, product: row.product, quantity: row.quantity, uom: row.uom, 
                  costingTarget: row.costingTarget, costingOwner: row.costingOwner, costingStatus: 'New', conversionStatus: 'Open',
                  spec1: row.spec1, spec2: row.spec2, spec3: row.spec3, spec4: row.spec4, spec5: row.spec5, spec6: row.spec6, 
                  spec7: row.spec7, spec8: row.spec8, spec9: row.spec9, spec10: row.spec10, spec11: row.spec11, spec12: row.spec12, 
                  spec13: row.spec13, spec14: row.spec14, spec15: row.spec15, pack: row.pack};
    const rows = [...enqProduct];
    rows.splice(row.serial, 0, newRow);
    const updatedRows = updateSerialNumber(rows);
    setEnqProduct(updatedRows);
    if (props.onRowSelection) {
      props.onRowSelection(updatedRows);
    }
  }

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    if (props.processRowUpdate) {
      props.processRowUpdate(originalRow);
    }
  }

  const handleDeleteAction = (row: any) => {
    if(row.order > 0) {
      appContext.setDialogMessage('The product has an order. Delete the order first.');
    } else if(row.costing > 0) {
      appContext.setDialogMessage('The product has a costing. Delete the costing first.');
    } else {
      const updatedRows = enqProduct.filter((r) => !(r.id === row.id));
      const serialRows = updateSerialNumber(updatedRows);
      setEnqProduct(serialRows);
      if (props.onRowDelete) {
        props.onRowDelete(serialRows);
      }
    }
  }

  return (
    <div>
      <Grid container spacing={1}>
        <IGridComponent title='Product Detail' rows={enqProduct} columns={columns} getRowId={(row: any) => row.id}
          apiRef={props.apiRef} showAction={true} handleDeleteAction={handleDeleteAction} showEditAction={false}
          showAddBtn={true} cellDoubleClick={handleCellDoubleClick} showDuplicateAction={true} handleDuplicateAction={copyRow}
          showApproveAction={false} showAddAction={false} showDownAction={false} showUpAction={false} 
          addRow={openProductPopup} hideFooterPagination={true} processRowUpdate={processRowUpdate} hideFooter={false}/>
      </Grid>
      <IDialogComponent onClose={handleClose} open={open} title='Select Product' 
        dialogBody={<SelectProductComponent onRowSelection={onRowSelection} />} />
      <IDialogComponent onClose={closeCellValuePopup} open={openCellValue} title={cellTitle}
        dialogBody={<TextComponent data={cellValueRow} close={closeCellValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closeValuePopup} open={openValue} title={cellTitle}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent data={cellValueRow} close={closePrdDetail}/>} />
      <YesNoDialog open={showMsgDialog} onClose={() => { setShowMsgDialog(false) }} 
        onOk={() => { setShowMsgDialog(false); onOkClick(); }} isHorizontal={true} message={message + ' Do you want to continue?'}  />
    </div>
  );
}

export default EnquiryProduct;
